import React from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import RightSideCalender from "./day-event/RightSideCalender";
import StudyPlaner from "./PopUp/StudyPlaner/StudyPlaner";
import {
  Day,
  Inject,
  Resize,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
} from "@syncfusion/ej2-react-schedule";
import HolidayList from "./HolidayList";
import { CirclePlus } from "lucide-react";

function StudyPlannerView({
  getCurrentFormattedDate,
  dateSelected,
  handleDateChange,
  onShowHolidays,
  onLactureTypeChange,
  onShowStudyPlannerPopup,
  createStudyPlanner,
  studyPlannerDeactive,
  studentDetails,
  dropDown,
  loading,
  onActionBegin,
  eventRendered,
  eventSettings,
  dragStart,
  resizeStart,
  cellDoubleClick,
  quickInfoTemplates,
  onCreated,
  onPopupOpen,
  dayEventTemplate,
  weekEventTemplate,
  scheduleRef,
}) {
  return (
    <div className="flex">
      <div className="col-11">
        <div className="flex justify-between mb-2">
          <div className="text-[#335c76] text-base font-semibold">

            {getCurrentFormattedDate(dateSelected)}
          </div>
          <div className="flex w-80 justify-between">
            <div
              className="d-flex align-items-center addStudeyPlanner studyPlanner"
              onClick={onShowStudyPlannerPopup}
            >
              <CirclePlus size={18} color="#335c76" /> &nbsp;
              <span className="text-[15px]">Add Study Planner</span>
            </div>
            <button
              className="listHolidaysBtn holidaysList"
              onClick={onShowHolidays}
            >
              List of Holidays
            </button>
          </div>
        </div>
        {loading ? (
          <img
            className="ongoing_internal_loader-self-ass"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        ) : (
          <ScheduleComponent
            className="dailyTTPane"
            ref={scheduleRef}
            // cssClass="schedule-overview"
            height="510px"
            width="100%"
            currentView="Week"
            startHour="06:00"
            endHour="24:00"
            cssClass="schedule-overview"
            actionBegin={onActionBegin}
            selectedDate={dateSelected}
            eventRendered={eventRendered}
            eventSettings={eventSettings}
            timeScale={{
              enable: true,
              interval: 30,
              slotCount: 1,
            }}
            dragStart={dragStart}
            resizeStart={resizeStart}
            cellClick={null}
            cellDoubleClick={cellDoubleClick}
            quickInfoTemplates={quickInfoTemplates}
            //allowDragAndDrop={}
            created={onCreated}
            // editorTemplate={this?.editorTemplate?.bind(this)}
            popupOpen={onPopupOpen}
          >
            <ViewsDirective>
              <ViewDirective option="Day" eventTemplate={dayEventTemplate} />
              <ViewDirective option="Week" eventTemplate={weekEventTemplate} />
            </ViewsDirective>
            <Inject services={[Day, Week, Resize]} />
          </ScheduleComponent>
        )}
        <style>
          {`
                        /* Increase row height */
                        .e-schedule .e-time-cells-wrap table td,
                        .e-schedule .e-work-cells {
                        height: 60px !important;
                        }
            
                        /* Time slot labels (left side) */
                        .e-schedule .e-time-cells {
                        font-weight: 600 !important;
                        font-size: 14px !important;
                        background-color: #fff0c5 !important;
                        color: #333 !important;
                        }
            
                        /* Header cells (day slots like Sun, Mon...) */
                        .e-schedule .e-header-cells {
                        font-weight: bold !important;
                        font-size: 14px !important;
                        background-color: #fff0c5 !important;
                        border-right: 1px solid #eee !important;
                        text-align: center !important;
                        vertical-align: middle !important;
                        }
            
                        .e-schedule {
                        border: 1px solid #d3d3d3  !important; /* dark gray border */
                        border-radius: 4px !important;
                        }
            
                        /* Day number and text */
                        .e-schedule .e-header-day,
                        .e-schedule .e-header-date {
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        line-height: 1.2 !important;
                        display: block !important;
                        }
            
                        .e-schedule .e-header-day {
                        font-size: 16px !important;
                        font-weight: 700 !important;
                        }
            
                        /* Calendar background */
                        .e-schedule .e-table {
                        background-color: #fffdf5 !important;
                        }
            
                        /* Cell border */
                        .e-schedule .e-work-cells {
                        border: 1px solid #f0e6cc !important;
                        }
            
            
                        /* Week/Month toggle buttons */
                        .e-schedule .e-toolbar-items .e-tbar-btn {
                        border-radius: 4px !important;
                        font-weight: 600 !important;
                        color: #333 !important;
                        }
            
                        .e-schedule .e-toolbar-items .e-tbar-btn.e-active {
                        background-color: #f57c00 !important;
                        color: white !important;
                        }
                        `}
        </style>
      </div>
      <div className="righ_side_box">
        <RightSideCalender change1={handleDateChange} />
      </div>
      {createStudyPlanner && (
        <StudyPlaner
          studyPlannerDeactive={studyPlannerDeactive}
          studentDetails={studentDetails}
          value={dropDown}
        />
      )}
    </div>
  );
}

export default StudyPlannerView;
